import tooltipDirective from './tooltip'

// register all directives
const directives = (app) => {
  const Vue = app // allow phpstorm to recognise global directives
  tooltipDirective(Vue)
}

export default directives
